import React, { useState } from 'react';
import { reviews, faqs } from '../data/storeData';
import SafeIcon from '../common/SafeIcon';
import { FiChevronRight, FiStar } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const ReviewsFAQ = () => {
  const [openFAQ, setOpenFAQ] = useState(0);

  return (
    <section id="faq" className="py-32 px-6 max-w-7xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-20">
        
        <div className="lg:col-span-5">
          <h2 className="text-4xl font-black uppercase tracking-tighter mb-12">
            Field <span className="text-zinc-600">Reports</span>
          </h2>
          <div className="space-y-6">
            {reviews.map((review) => (
              <div key={review.id} className="glass-panel p-8 rounded-2xl relative overflow-hidden group">
                <div className="absolute top-0 left-0 w-1 h-full bg-fuchsia-500 opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="flex gap-1 text-fuchsia-500 mb-4">
                  {[...Array(review.rating)].map((_, i) => (
                    <SafeIcon key={i} icon={FiStar} className="text-[10px] fill-current" />
                  ))}
                </div>
                <p className="text-zinc-300 text-sm leading-relaxed mb-6 italic">"{review.text}"</p>
                <p className="text-[10px] font-black uppercase tracking-[0.2em] text-zinc-500">{review.user}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7">
          <h2 className="text-4xl font-black uppercase tracking-tighter mb-12">
            System <span className="text-zinc-600">Intel</span>
          </h2>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className={`transition-all duration-500 rounded-2xl border ${
                openFAQ === index ? 'bg-zinc-900 border-white/20' : 'bg-transparent border-white/5'
              }`}>
                <button 
                  onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                  className="w-full flex justify-between items-center p-6 text-left"
                >
                  <span className={`text-sm font-black uppercase tracking-widest transition-colors ${
                    openFAQ === index ? 'text-cyan-400' : 'text-zinc-400'
                  }`}>
                    {faq.q}
                  </span>
                  <SafeIcon 
                    icon={FiChevronRight} 
                    className={`transition-transform duration-500 ${openFAQ === index ? 'rotate-90 text-cyan-400' : 'text-zinc-600'}`} 
                  />
                </button>
                <AnimatePresence>
                  {openFAQ === index && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      className="overflow-hidden"
                    >
                      <div className="p-6 pt-0 text-zinc-400 text-sm leading-relaxed border-t border-white/5 mt-2">
                        {faq.a}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default ReviewsFAQ;